module.exports = __webpack_public_path__ + "static/contentselection-textcontrast-do-4c23d98b466c7825c07fc1280619942f.png";